import { render } from "./App.vue?vue&type=template&id=44487d58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=44487d58&lang=scss"

import exportComponent from "/Users/huangliu/Desktop/work/2024/develop/fdyun/ycx-website/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__